import { Reveal, Eyebrow } from "./Reveal";

const SERVICE_CLIPS = [1, 4, 6].map((n) => ({ webm: `/videos/usp-${n}.webm`, mp4: `/videos/usp-${n}.mp4` }));

export const Services = ({ t }) => (
  <section id="leistungen" data-testid="services-section" className="relative py-24 sm:py-32 px-4 bg-[#E9F3F4]">
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-3xl">
        <Eyebrow>{t.services.label}</Eyebrow>
        <h2 className="mt-4 font-jakarta text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          {t.services.title}
        </h2>
      </Reveal>

      <div className="mt-14 space-y-8">
        {t.services.chapters.map((chapter, i) => (
          <Reveal key={chapter.num} delay={0.05}>
            <div
              data-testid={`service-chapter-${chapter.num}`}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-8 p-8 sm:p-12 rounded-3xl bg-surface border border-slate-200 hover:border-[#003940]/40 shadow-sm hover:shadow-xl transition-all duration-300 items-center"
            >
              <div className="lg:col-span-2">
                <span className="text-6xl sm:text-7xl font-black font-mono text-[#003940]/15 group-hover:text-[#003940] transition-colors duration-300">
                  {chapter.num}
                </span>
              </div>
              <div className="lg:col-span-6">
                <span className="inline-block text-xs font-mono uppercase tracking-[0.2em] text-[#003940] border border-[#003940]/25 rounded-full px-3 py-1 bg-[#003940]/5">
                  {chapter.tag}
                </span>
                <h3 className="mt-4 text-xl sm:text-2xl font-semibold tracking-tight text-slate-900">{chapter.title}</h3>
                <p className="mt-4 text-sm sm:text-base text-slate-600 leading-relaxed">{chapter.text}</p>
              </div>
              <div className="lg:col-span-4">
                <div className="relative overflow-hidden rounded-2xl aspect-[4/3] border border-slate-200 bg-[#0A272C]">
                  <video
                    data-testid={`service-video-${chapter.num}`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    aria-label={chapter.title}
                  >
                    <source src={SERVICE_CLIPS[i].webm} type="video/webm" />
                    <source src={SERVICE_CLIPS[i].mp4} type="video/mp4" />
                  </video>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A272C]/30 to-transparent pointer-events-none" />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="services-extra"
          className="mt-8 p-8 sm:p-10 rounded-3xl border border-dashed border-[#003940]/30 bg-surface/60 flex flex-col sm:flex-row items-start gap-4"
        >
          <span className="shrink-0 text-xs font-mono uppercase tracking-[0.2em] text-[#003940] border border-[#003940]/25 rounded-full px-3 py-1 bg-[#003940]/5">
            {t.services.extraTag}
          </span>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed">{t.services.extra}</p>
        </div>
      </Reveal>
    </div>
  </section>
);
